var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_4163_13535)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint1_linear_4163_13535)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#4FA657"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint2_linear_4163_13535)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FF784D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 25.75C25.6642 25.75 26 25.4142 26 25C26 24.5858 25.6642 24.25 25.25 24.25C24.8358 24.25 24.5 24.5858 24.5 25C24.5 25.4142 24.8358 25.75 25.25 25.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 25.75C28.1642 25.75 28.5 25.4142 28.5 25C28.5 24.5858 28.1642 24.25 27.75 24.25C27.3358 24.25 27 24.5858 27 25C27 25.4142 27.3358 25.75 27.75 25.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 25.75C30.6642 25.75 31 25.4142 31 25C31 24.5858 30.6642 24.25 30.25 24.25C29.8358 24.25 29.5 24.5858 29.5 25C29.5 25.4142 29.8358 25.75 30.25 25.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.75 30V24.5C42.75 22.705 41.295 21.25 39.5 21.25H24.5C22.705 21.25 21.25 22.705 21.25 24.5V39.5C21.25 41.295 22.705 42.75 24.5 42.75H30C30.414 42.75 30.75 42.414 30.75 42C30.75 41.586 30.414 41.25 30 41.25H24.5C23.533 41.25 22.75 40.467 22.75 39.5V24.5C22.75 23.533 23.533 22.75 24.5 22.75H39.5C40.467 22.75 41.25 23.533 41.25 24.5V30C41.25 30.414 41.586 30.75 42 30.75C42.414 30.75 42.75 30.414 42.75 30Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 27.25H22C21.586 27.25 21.25 27.586 21.25 28C21.25 28.414 21.586 28.75 22 28.75H42C42.414 28.75 42.75 28.414 42.75 28C42.75 27.586 42.414 27.25 42 27.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 30.25C33.051 30.25 30.25 33.051 30.25 36.5C30.25 39.949 33.051 42.75 36.5 42.75C39.949 42.75 42.75 39.949 42.75 36.5C42.75 33.051 39.949 30.25 36.5 30.25ZM36.5 31.75C39.122 31.75 41.25 33.878 41.25 36.5C41.25 39.122 39.122 41.25 36.5 41.25C33.878 41.25 31.75 39.122 31.75 36.5C31.75 33.878 33.878 31.75 36.5 31.75Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.25 38.75V34.25C37.25 33.836 36.914 33.5 36.5 33.5C36.086 33.5 35.75 33.836 35.75 34.25V38.75C35.75 39.164 36.086 39.5 36.5 39.5C36.914 39.5 37.25 39.164 37.25 38.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0298 35.7198L37.0298 33.7198C36.7368 33.4267 36.2627 33.4267 35.9697 33.7198L33.9698 35.7198C33.6768 36.0118 33.6768 36.4878 33.9698 36.7798C34.2617 37.0728 34.7377 37.0728 35.0297 36.7798L36.4997 35.3107L37.9697 36.7798C38.2617 37.0728 38.7378 37.0728 39.0298 36.7798C39.3228 36.4878 39.3228 36.0118 39.0298 35.7198Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4163_13535",
    x1: 60,
    y1: 50.5,
    x2: -8.94069e-8,
    y2: -5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD374E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF495E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4163_13535",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4163_13535",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63B967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA64F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.e9805cd91e4a41f8a64c77f67d007669.svg";
export { ForwardRef as ReactComponent };